// extracted by mini-css-extract-plugin
module.exports = {"top_pick_container":"style_top_pick_container__DzN8_","icon":"style_icon__zZG1v"};